import React, { useState, useContext, useEffect } from "react";
import { NavLink, Link, useParams, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { GiSettingsKnobs } from "react-icons/gi";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { FaPen } from "react-icons/fa";

import {
  InputGroup,
  Dropdown,
  Popover,
  OverlayTrigger,
  Form,
  Modal,
} from "react-bootstrap";
import LandLordCard from "../components/landlord/LandLordCard";
import Properties from "../components/landlord/Properties";
import { Ucontext } from "../context/Ucontext";
import {
  fetchAgencyDetails,
  landlordLoadSharedProfiles,
  updateCompanyData,
} from "../context/functions/AdminFunction";
import toast from "react-hot-toast";
import LandlordDocuments from "../components/landlord/LandlordDocuments";
import { BASE_URL, CDN_CONTAINER, CDN_ENDPOINT } from "../config";
import { constants } from "../utils/constants";
import { haveValue } from "../utils/common";

const LandLordDetail = () => {
  const { landlordid } = useParams();
  const queryParameters = new URLSearchParams(window.location.search);
  const openEditModal = queryParameters.get("editCompany") || false;
  const {
    adminDispatch,
    adminState,
    getSingleUser,
    getLandlordProperties,
    getLandlordPropertyDetails,
    updateUserInfo,
    authState,
  } = useContext(Ucontext);
  const { totalLandlords, totalProperties } = adminState;
  const { user: adminUser } = authState;

  const [loading, setLoading] = useState(false);
  const [landlord, setLandlord] = useState({});
  const [properties, setProperties] = useState([]);
  const [filteredProp, setFilteredProp] = useState([]);
  const [propertiesDetails, setPropertiesDetails] = useState([]);
  const [sharedProfile, setSharedProfiles] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [iban_num, setIban_num] = useState("");
  const [showIban, setShowIban] = useState(false);
  const [showEditDetails, setShowEditDetails] = useState(openEditModal);
  const [editDetailsData, setEditDetailsData] = useState({
    id: null,
    file: landlord?.company_logo,
    company_name: landlord?.company_name,
    custom_url: landlord?.custom_url,
    company_url: landlord?.company_url,
    agency_type: landlord?.agency_type || "agent",
  });
  const [companyImagePreview, setCompanyImagePreview] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    loadLandlord();
    loadProperties();
    navigate(`/landlorddetail/${landlordid}`);
  }, []);

  useEffect(() => {
    setIban_num(landlord?.iban_num);
    if (haveValue(landlord?.agency_id)) {
      getAgencyDetails(landlord?.agency_id);
    }
  }, [landlord]);

  useEffect(() => {
    const temp = propertiesDetails.filter((property) => {
      const addr = `${property?.street} ${property?.street_number} ${property?.floor_number} ${property?.flat_number} ${property?.postcode} ${property?.muncipality}`;
      if (
        haveValue(searchVal) &&
        addr.toLowerCase().includes(searchVal.toLowerCase())
      )
        return property;
    });
    console.log(temp);
    setFilteredProp(temp);
  }, [searchVal]);

  const loadLandlord = async () => {
    setLoading(true);
    let landlord = await getSingleUser(landlordid, "landlord");
    setLandlord(landlord);
    setLoading(false);
  };

  const loadProperties = async () => {
    setLoading(true);
    let landlord = await getLandlordProperties(landlordid);
    let details = await getLandlordPropertyDetails(landlordid);
    let sharedProfile1 = await landlordLoadSharedProfiles(landlordid);

    setSharedProfiles(sharedProfile1);
    setProperties(landlord?.properties);
    setFilteredProp(details?.properties);
    setPropertiesDetails(details?.properties);
    setLoading(false);
  };

  const handleSearch = (e) => {
    setSearchVal(e.target.value);
  };

  const handleChangeIBAN = (e) => {
    setIban_num(e.target.value);
  };

  const saveIban = () => {
    updateUserInfo({ iban_num }, landlordid, "landlord")
      .then((res) => {
        toast.success("Landlord Updated");
        setShowIban(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUploadFile = (e) => {
    const files = e.target.files;
    let file = files[0];
    // Check file size
    const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
    if (file.size > maxSizeInBytes) {
      alert("File size exceeds maximum limit (2MB)");
      return false;
    }

    //create file reader object
    const reader = new FileReader();
    //Listen to the "load" event and get the result (base64 encoded string)
    reader.onload = (e) => {
      setCompanyImagePreview(e.target.result);
    };
    //Read the file as data URL (base64 format)
    reader.readAsDataURL(file);

    setEditDetailsData((prev) => ({ ...prev, file: file }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name == "company_url") {
      const sanitizedValue = value.replace(/[^a-zA-Z]/g, "");
      // Only update the state if the input matches the regex (i.e., only alphabetic characters)
      setEditDetailsData((prev) => ({ ...prev, [name]: sanitizedValue }));
    } else {
      setEditDetailsData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const getAgencyDetails = (agency_id) => {
    fetchAgencyDetails(agency_id)
      .then((res) => {
        const data = res.data.success_res;
        setEditDetailsData({
          id: data?._id,
          file: data?.company_logo,
          company_name: data?.company_name,
          custom_url: haveValue(data?.company_url),
          company_url: data?.company_url,
          agency_type: data?.agency_type || "agent",
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUpdateCompany = () => {
    const formData = new FormData();

    formData.append("company_name", editDetailsData?.company_name);
    formData.append("file", editDetailsData?.file);
    formData.append("custom_url", editDetailsData?.custom_url);
    formData.append("company_url", editDetailsData?.company_url);
    formData.append("agency_type", editDetailsData?.agency_type || "agent");
    formData.append("edit_id", editDetailsData?.id);
    updateCompanyData(formData, landlord?._id)
      .then((res) => {
        console.log(res, "Response for updating company details");
        if (res.status == 200) {
          setShowEditDetails(false);
          loadLandlord();
        }
      })
      .catch((err) => {
        console.log(err, "Error while updating Company Details");
      });
  };

  console.log(
    editDetailsData,
    "67d7f25a91fe1915373bf15467d7f25a91fe1915373bf154"
  );

  if (loading) return <h1>Loading...</h1>;
  return (
    <>
      <NavLink to="/landlord">
        <IoIosArrowBack color="var(--dark)" size={25} />
      </NavLink>
      <div className="property_text d-flex justify-content-between">
        <div className="header_table">
          <h1>Details</h1>
        </div>
      </div>
      <div className="verticle_gap_in_components">
        {adminUser?.role == constants.SUPER_ADMIN && (
          <div className=" vertical-gap-input-box">
            <input
              type="text"
              id="iban_num"
              name="iban_num"
              value={iban_num}
              onChange={handleChangeIBAN}
              disabled={!showIban}
            />
            {showIban ? (
              <>
                <button className="me-1 ms-1" onClick={saveIban}>
                  Save
                </button>
                <button className="me-1" onClick={(e) => setShowIban(false)}>
                  Cancel
                </button>
              </>
            ) : (
              <button className="me-1 ms-1" onClick={(e) => setShowIban(true)}>
                Edit
              </button>
            )}
          </div>
        )}
        {landlord?.isLandlordInComp == "company" && (
          <div className="landlorad-detail-page-head">
            <button
              className="btn lanloard-admin-head-btn"
              onClick={(e) => setShowEditDetails(true)}
            >
              Edit Company Details
            </button>
            <div className="searchbar_table">
              <div>
                <InputGroup className="input_table_header">
                  <InputGroup.Text id="basic-addon1">
                    <HiMagnifyingGlass />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                    value={searchVal}
                    onChange={handleSearch}
                  />
                </InputGroup>
              </div>
            </div>
          </div>
        )}
        <LandLordCard
          landlord={landlord}
          properties={properties}
          sharedProfile={sharedProfile}
        />
        <Properties sharedProfile={sharedProfile} properties={filteredProp} />
        {landlord?.isLandlordInComp == "company" && (
          <LandlordDocuments landlord={landlord} />
        )}

        <Modal
          show={showEditDetails}
          onHide={(e) => {
            setShowEditDetails(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter company-detail-edit-modal"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Change Company Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="mb-3">
            <div className="edit_form_details company-edit-profile row">
              <div className="logo-main-box col-3 m-auto">
                <p>Company Logo</p>
                <div className="company-logo-box">
                  <div className="image-box">
                    <img
                      src={
                        companyImagePreview
                          ? companyImagePreview
                          : `${CDN_ENDPOINT}/${CDN_CONTAINER}/${editDetailsData?.file} `
                      }
                      alt="Company Logo"
                    />
                  </div>
                  <label className="file-update-btn">
                    <FaPen />
                    <input
                      type="file"
                      name="company_logo"
                      accept="image/png, image/jpeg"
                      // value={editDetailsData?.file}
                      onChange={(e) => handleUploadFile(e)}
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="company-name-box col-6">
                <p>Company Name</p>
                <input
                  type="text"
                  value={editDetailsData?.company_name}
                  name="company_name"
                  onChange={handleInputChange}
                  className="form-control"
                />
              </div>
              <LandlordDocuments landlord={landlord} />
              <div className="company-name-box col-6">
                <p>Agency Type</p>
                <select
                  name="agency_type"
                  id="agency_type"
                  className="w-100"
                  onChange={handleInputChange}
                  value={editDetailsData?.agency_type}
                >
                  <option value="agent">Agent</option>
                  <option value="landlord">Landlord</option>
                </select>
              </div>
            </div>
            <div>
              <label>
                <input
                  type="checkbox"
                  name="custom_url"
                  onChange={(e) =>
                    setEditDetailsData((prev) => ({
                      ...prev,
                      custom_url: !editDetailsData?.custom_url,
                    }))
                  }
                  checked={editDetailsData?.custom_url}
                />{" "}
                <span>Do you want to add custom Login page?</span>
              </label>
            </div>
            {editDetailsData?.custom_url && (
              <>
                <div className="company-name-box col-6 mb-3">
                  <p className="mt-2">Company Name</p>
                  <input
                    type="text"
                    value={editDetailsData?.company_url}
                    name="company_url"
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="">
            <button className="doc-footer-btn" onClick={handleUpdateCompany}>
              Update
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default LandLordDetail;
